<template>
  <div>
    <base-panel
      :asset="asset"
      :tabs="tabs"
      :asset-module="assetModule"
      :hide-print-button="false"
      :last-update="lastUpdate"
      :hide-tabs="hideTabs"
      :notifications="notifications"
    />
  </div>
</template>

<script>
import globalEventBus from '@/services/globalEventBus';
import events from '@/domain/events/engineering';
import tabNames from '@/domain/enums/installation/engineering/commutatorMaintenance/commutatorMaintenanceTabs';
import BasePanel from '@/domain/components/installation/engineering/BasePanel';
import GeneralTab from '@/domain/components/installation/engineering/commutatorMaintenance/GeneralTab';
import ParametersTab from '@/domain/components/installation/engineering/commutatorMaintenance/ParametersTab';
import DefaultCommutatorTab from '@/domain/components/installation/engineering/commutatorMaintenance/DefaultCommutatorTab';
import Service from '@/domain/services/installation/engineering/commutatorMaintenance/commutatorMaintenance';
import { pushAlert } from '@/services/messages/alertService';

export default {
  name: 'commutatorMaintenance',
  components: {
    BasePanel,
  },
  props: {
    asset: {
      type: Object,
      default: () => ({}),
    },
    assetModule: Object,
    notifications: {
      type: Array,
      default: () => [],
    },
  },
  data: vm => ({
    commutatorsAmount: null,
    lastUpdate: '',
    hideTabs: true,
    tabs: [
      {
        name: tabNames.GENERAL,
        title: vm.$t('general.general'),
        component: GeneralTab,
        commutatorsAmount: vm.commutatorsAmount,
      },
      {
        name: tabNames.COMMUTATOR_PARAMETERS,
        title: vm.$t('general.parameters'),
        component: ParametersTab,
        commutatorsAmount: vm.commutatorsAmount,
        showTooltip: true,
        tooltipMessage: 'messages.MI023.message',
      },
    ],
  }),
  created() {
    this.getCommutatorStatus(true);
    this.initListener();
  },
  beforeDestroy() {
    this.removeListener();
  },
  methods: {
    addNewTabs() {
      const defaultTabs = [
        {
          name: tabNames.GENERAL,
          title: this.$t('general.general'),
          component: GeneralTab,
          commutatorsAmount: this.commutatorsAmount,
        },
        {
          name: tabNames.COMMUTATOR_PARAMETERS,
          title: this.$t('general.parameters'),
          component: ParametersTab,
          commutatorsAmount: this.commutatorsAmount,
          showTooltip: true,
          tooltipMessage: 'messages.MI023.message',
        },
      ];
      for (let index = 1; index <= this.commutatorsAmount; index += 1) {
        defaultTabs.splice(index, 0, this.tabToAdd(index));
      }
      this.tabs = defaultTabs;
    },
    tabToAdd(index) {
      return {
        name: `${tabNames.COMMUTATOR}${index}`,
        title: this.$t('general.commutator', { CommutatorNumber: index }),
        commutatorId: index,
        component: DefaultCommutatorTab,
        commutatorsAmount: this.commutatorsAmount,
      };
    },
    async getCommutatorStatus(showLoading = false) {
      const { id } = this.assetModule;
      try {
        await this.showStatus(id);
      } catch (error) {
        await this.tryInsertDefaultParameters(id);
      } finally {
        if (this.commutatorsAmount > 0) {
          this.addNewTabs();
          this.hideTabs = false;
          globalEventBus.emit(events.refreshDataTab, showLoading);
        }
      }
    },
    async showStatus(id) {
      const status = await Service.getStatus(id);
      this.commutatorsAmount = status.commutatorsAmount;
      this.lastUpdate = status.lastUpdate;
    },
    async tryInsertDefaultParameters(id) {
      try {
        await Service.setDefaultParameters(id);
        await this.showStatus(id);
      } catch {
        this.commutatorsAmount = 0;
        pushAlert({ code: 'ME022' });
      }
    },
    refreshDataEvent({ wait }) {
      wait(this.getCommutatorStatus());
    },
    initListener() {
      globalEventBus.on(events.refreshData, this.refreshDataEvent, this);
    },
    removeListener() {
      globalEventBus.off(events.refreshData, this.refreshDataEvent, this);
    },
  },

};
</script>

